const MISSING_RE = /^(n\/a|na|none|null|undefined|nan|could not catch)$/i
const BULLET_CHAR = String.fromCharCode(8226)
const MOJIBAKE_BULLET_RE = /\u00e2\u20ac\u00a2/g
const MOJIBAKE_NBSP_RE = /\u00c2\u00a0/g

export function cleanBulletText (value) {
  return String(value == null ? '' : value)
    .replace(MOJIBAKE_NBSP_RE, ' ')
    .replace(/\u00a0/g, ' ')
    .replace(MOJIBAKE_BULLET_RE, BULLET_CHAR)
    .replace(/^[\s\u2022*-]+/, '')
    .replace(/\s+/g, ' ')
    .trim()
}

function hasBulletValue (value) {
  const text = cleanBulletText(value)
  return !!text && !MISSING_RE.test(text)
}

function dedupeBullets (items) {
  const seen = {}
  const out = []
  items.forEach((item) => {
    const clean = cleanBulletText(item)
    if (!hasBulletValue(clean)) return
    const key = clean.toLowerCase()
    if (seen[key]) return
    seen[key] = true
    out.push(clean)
  })
  return out
}

function splitByPattern (text, pattern) {
  const parts = text.split(pattern).map(cleanBulletText).filter(hasBulletValue)
  return parts.length > 1 ? parts : null
}

function splitFlattenedHeadingBullets (text) {
  const marked = text.replace(
    /([.!?])\s+(?=[A-Z0-9][A-Za-z0-9+&/() ,.-]{2,70}\s*:\s+\S)/g,
    '$1\n'
  )
  if (marked === text) return null
  return splitByPattern(marked, /\r?\n+/)
}

function parseMaybeJsonArray (value) {
  if (typeof value !== 'string') return null
  const text = value.trim()
  if (!text || (text[0] !== '[' && text[0] !== '"')) return null
  try {
    const parsed = JSON.parse(text)
    if (Array.isArray(parsed)) return parsed
    if (typeof parsed === 'string') return [parsed]
  } catch (e) {
    return null
  }
  return null
}

export function normalizeBulletList (value) {
  if (Array.isArray(value)) return dedupeBullets(value)

  const parsed = parseMaybeJsonArray(value)
  if (parsed) return dedupeBullets(parsed)

  const text = cleanBulletText(value)
  if (!hasBulletValue(text)) return []

  const structuralSplits = [
    /\r?\n+/,
    /\s+\|\s+/,
    /\s+\u2022\s+/,
    /\s+\*\s+/,
    /\s*;\s*(?=\S)/
  ]

  for (let i = 0; i < structuralSplits.length; i++) {
    const split = splitByPattern(text, structuralSplits[i])
    if (split) return dedupeBullets(split)
  }

  const headingSplit = splitFlattenedHeadingBullets(text)
  if (headingSplit) return dedupeBullets(headingSplit)

  return dedupeBullets([text])
}
